import { FormattedMessage } from 'react-intl'

import { Badge } from '@gto/ui/badge'
import { ClockIcon } from '@gto/ui/icons/outline'
import { Typography } from '@gto/ui/typography'

export const PromoOffersHeader = () => {
  return (
    <section className="flex flex-col items-center justify-center gap-6">
      <div>
        <Badge
          className="gap-1"
          color="primary"
          variant="default"
        >
          <ClockIcon
            color="inherit"
            height={28}
            width={28}
          />
          <FormattedMessage id="promo.page.offers.limitedTimeOffer" />
        </Badge>
      </div>
      <Typography variant="h4">
        <FormattedMessage id="promo.page.offers.title" />
      </Typography>
      <Typography variant="body1">
        <FormattedMessage id="promo.page.offers.description" />
      </Typography>
    </section>
  )
}
